import { AsyncPipe, NgIf } from '@angular/common';
import { Component, Input, Self } from '@angular/core';
import {
  CheckoutCustomerDetailsComponent,
  CheckoutProgressionStepsComponent,
} from '@checkout/feature-components';
import { BasketSummaryComponent } from '@domgen/dgx-fe-basket';
import { CmsArea } from '@domgen/dgx-fe-cms';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { GAPage } from '@domgen/dgx-fe-ga';
import { EditableArea } from '@magnolia/angular-editor';
import { PaymentMethodFormComponent } from '../../components/payment-method-form/payment-method-form.component';
import { PaymentMethodComponentService } from '../../services/payment-method-component/payment-method-component.service';

@Component({
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss'],
  providers: [PaymentMethodComponentService],
  standalone: true,
  imports: [
    NgIf,
    GridSectionComponent,
    GridContainerComponent,
    GridRowComponent,
    GridColumnComponent,
    CheckoutProgressionStepsComponent,
    CheckoutCustomerDetailsComponent,
    PaymentMethodFormComponent,
    BasketSummaryComponent,
    EditableArea,
    AsyncPipe,
  ],
})
@GAPage()
export class PaymentMethodComponent {
  @Input() main!: CmsArea;

  constructor(@Self() readonly cs: PaymentMethodComponentService) {}
}
